export const enum TemplateIds {
  PriceCalendar = 'priceCalendar',
  HotelDetailsStays = 'hotelDetailsStays',
  HotelDetailsHeader = 'hotelDetailsHeader',
}
